"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const labelFactory = () => ComposedComponent => {
  class TooltippedLabel extends _react.PureComponent {
    render() {
      return _react.default.createElement(_styles.Tooltip, {
        className: this.props.className,
        target: ComposedComponent,
        tooltip: this.props.tooltip || this.props.text,
        text: this.props.text,
        additionNode: this.props.additionNode,
        tooltipShowOnClick: true
      });
    }
  }
  TooltippedLabel.defaultProps = {
    tooltip: '',
    additionNode: null
  };
  return TooltippedLabel;
};
var _default = exports.default = labelFactory;